import React, { useContext, useEffect, useState } from 'react';
import { SharedExperiencePageContext } from './sharedExperiencePageContext';
import { SharedExperiencesContext } from '../../lib/sharedExperiencesProvider';
import { useSharedExperiencesApi } from '../../lib/useSharedExperiencesApi';
import useExperienceApi from '../../../experiences/lib/useExperienceApi';
import { useLocation } from 'react-router-dom';

export default function SharedExperiencePageProvider({ children }) {
  const { sharedExperienceId } = useContext(SharedExperiencesContext);
  const sharedExperiencesApi = useSharedExperiencesApi();
  const experienceApi = useExperienceApi();
  const [isFetchingExperiences, setIsFetchingExperiences] = useState(false);
  const [isFetchingSharedExperiences, setIsFetchingSharedExperiences] = useState(false);
  const [experienceList, setExperienceList] = useState(null);
  const [experienceGroupList, setExperienceGroupList] = useState(null);
  const [sharedExperienceList, setSharedExperienceList] = useState(null);
  const [init, setInit] = useState(false);
  const [previousSharedExperienceId, setPreviousSharedExperienceId] = useState(null);
  const [group, setGroup] = useState(null);
  const [parentGroup, setParentGroup] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const groupId = searchParams.get('group-id');
  
  const refreshSharedExperienceList = async () => {
    try {
      setIsFetchingSharedExperiences(true);
      const newSharedExperienceList = await sharedExperiencesApi.fetchSharedExperiencesBySharedExperienceId(sharedExperienceId);
      setSharedExperienceList(newSharedExperienceList || []);
      setIsFetchingSharedExperiences(false);
    } catch (error) {
      console.error('❌ Error in refreshSharedExperienceList:', error);
      setIsFetchingSharedExperiences(false);
    }
  };
  
  const refreshExperienceList = async () => {
    try {
      setIsFetchingExperiences(true);
      const result = await Promise.all([
        experienceApi.fetchExperiencesBySharedExperienceId(sharedExperienceId),
        experienceApi.fetchExperienceGroupsBySharedExperienceId(sharedExperienceId),
        sharedExperiencesApi.fetchSharedExperiencesBySharedExperienceId(sharedExperienceId)
      ]);
      setExperienceList(result[0] || []);
      setExperienceGroupList(result[1] || []);
      setSharedExperienceList(result[2] || []);
    } catch (error) {
      console.error('❌ Error in refreshExperienceList:', error);
    } finally {
      setIsFetchingExperiences(false);
    }
  };
  const refresh = async () => {
    await refreshExperienceList();
  };
  const refreshPersonaList = () => {
    setRefreshTrigger(prev => prev + 1);
  };
  const refreshProductList = () => {
    setRefreshTrigger(prev => prev + 1);
  };
  useEffect(() => {
    if (sharedExperienceId) {
      if (!init || sharedExperienceId !== previousSharedExperienceId) {
        setPreviousSharedExperienceId(sharedExperienceId);
        refreshExperienceList();
        refreshSharedExperienceList();
        setInit(true);
      }
    }
  }, [sharedExperienceId]);
  useEffect(() => {
    if (experienceGroupList) {
      if (groupId) {
        const newGroup = experienceGroupList.find(g => g.id === parseInt(groupId));
        setGroup(newGroup);
        if (newGroup) {
          const parentGroup = experienceGroupList.find(g => newGroup.group_id === g.group.id);
          setParentGroup(parentGroup);
        }
      } else {
        setGroup(null);
        setParentGroup(null);
      }
    }
  }, [groupId, experienceGroupList]);
  return (
    <SharedExperiencePageContext.Provider value={{
      isFetchingExperiences,
      isFetchingSharedExperiences,
      experienceList,
      experienceGroupList,
      sharedExperienceList,
      refreshExperienceList,
      refreshSharedExperienceList,
      refresh,
      refreshPersonaList,
      refreshProductList,
      refreshTrigger,
      group,
      parentGroup,
      setGroup,
    }}>
      {children}
    </SharedExperiencePageContext.Provider>
  );
} 